export enum SoilingRiskAssessment {
  LOW = 'LOW',
  HIGH = 'HIGH',
  UNDEFINED = '-',
}
